<template>
  <div class="d-flex flex-column justify-content-center mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <b-dropdown :text="perPage.toString()" variant="outline-gray-800 mr-1">
          <b-dropdown-item
            v-for="amount in perPageAmounts"
            :key="amount"
            :active="isActive(amount)"
            :disabled="isDisabled(amount)"
            @click.stop="setPerPage(amount)"
          >
            {{ amount }}
          </b-dropdown-item>
        </b-dropdown>

        <b-button
          variant="outline-gray-800"
          class="p-2"
          :class="filtersButtonClass"
          @click.stop="toggleFilters"
        >
          {{ $t("list.filters") }}
        </b-button>
      </div>
      <div class="ml-auto">
        <b-dropdown
          v-if="removeSelected && havePermissionToRemove"
          :text="$t('list.tools')"
          class="p-0"
          variant="outline-primary"
          right
        >
          <b-dropdown-item-button @click.stop="callRemoveSelectedItems">
            {{ $t("actions.remove_selected") }}
          </b-dropdown-item-button>
          <slot name="tools" />
        </b-dropdown>

        <slot name="actions" />

        <b-button
          v-if="hasCreateRoute && havePermissionToCreate"
          variant="primary"
          :to="{ name: createRoute }"
          class="ml-1 p-2"
        >
          <font-awesome-icon :icon="icon.plus" />
          {{ $t("list.new") }}
        </b-button>
      </div>
    </div>

    <filters
      v-if="showFilters"
      :filters="filters"
      @updateFilters="updateFilters"
    />
  </div>
</template>

<script>
import {
  faPlusSquare,
  faThumbsUp,
  faThumbsDown
} from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import filters from '@/components/common/listFilters'
import { perPageAmounts } from '@/config/list'

export default {
  components: {
    FontAwesomeIcon,
    filters
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    createRoute: {
      type: String,
      required: false,
      default: null
    },
    total: {
      type: Number,
      required: true
    },
    removeSelected: {
      type: Boolean,
      required: false,
      default: true
    },
    havePermissionToCreate: {
      type: Boolean,
      required: false,
      default: true
    },
    havePermissionToRemove: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
    showFilters: false,
    filterColumns: false,
    perPageAmounts,
    icon: {
      thumbsDown: faThumbsDown,
      thumbsUp: faThumbsUp,
      plus: faPlusSquare
    }
  }),
  computed: {
    hasCreateRoute() {
      return this.createRoute !== null
    },
    filtersButtonClass() {
      return this.showFilters ? 'active' : ''
    }
  },
  created() {
    this.checkCurrentFilters()
  },
  methods: {
    isDisabled(value) {
      return this.isAboveTotal(value) || this.isActive(value)
    },
    isAboveTotal(value) {
      return value > this.total
    },
    isActive(value) {
      return this.perPage == value
    },
    setPerPage(perPage) {
      this.$emit('updatePerPage', perPage)
    },
    toggleFilters() {
      this.showFilters = !this.showFilters
    },
    checkCurrentFilters() {
      this.showFilters = this.filters.some(
        f =>
          (this.isObject(f.model) && f.model.startDate) ||
          (!this.isObject(f.model) && f.model)
      )
    },
    updateFilters(filters) {
      this.$emit('updateFilters', filters)
    },
    callRemoveSelectedItems() {
      this.$emit('removeSelectedItems')
    },
    isObject(item) {
      return typeof item === 'object' && item !== null
    }
  }
}
</script>
